import { UtilityTariffsDatabaseSubtitle } from './catalogue/UtilityTariffsDatabaseSubtitle'

export default {
  list: { lazy: () => import('./UtilityTariff'), component: 'UtilityTariffList' },
  edit: { lazy: () => import('./UtilityTariff'), component: 'UtilityTariffEdit' },
  create: { lazy: () => import('./UtilityTariff'), component: 'UtilityTariffCreate' },
  options: {
    create: {
      title: 'Create Utility Tariff',
      subtitle: null,
      breadCrumb: 'Create Utility Tariff',
    },
    list: {
      title: 'Utility Tariffs Database',
      subtitle: <UtilityTariffsDatabaseSubtitle />,
      breadCrumb: 'Utility Tariffs',
    },
    edit: {
      title: 'Edit Utility Tariff',
      subtitle: null,
      breadCrumb: 'Edit Utility Tariff',
    },
  },
}

export const customTariffProposed = { edit: { lazy: () => import('./UtilityTariff'), component: 'UtilityTariffEdit' } }

export const customTariffCurrent = { edit: { lazy: () => import('./UtilityTariff'), component: 'UtilityTariffEdit' } }
